const throwError = (variableName: string) => {
  throw new Error(
    `Environment variable ${variableName} is required for operation`,
  );
};

const getConfig = () => ({
  ENV: process.env.NODE_ENV,
  RESTREAM_WEB_API_HOST:
    process.env.REACT_APP_RESTREAM_API_HOST ||
    throwError('RESTREAM_WEB_API_HOST'),
});

export const config = getConfig();
